<template>
  <div>
    <datatable
      title="Admins"
      @delete="deleteAdmin"
      @create="createAdmin"
      @edit_click="editClick"
      @set_active_list="setActiveList"
      @set_expired_list="setExpiredList"
      @set_blocked_list="setBlockedList"
      :unique_buttons="unique_buttons"
      :fields="fields"
      :response="admins"></datatable>
  </div>
</template>
<script>
// imports
import { mapActions, mapMutations, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
// constants
import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/admin_list/types'
// exports
export default {
  name: 'admin-list',
  created: function () {
    this[FETCH_ALL]()
  },
  data () {
    return {
      stagedStatus: 'active',
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'Full Name',
          value: 'full_name',
          component: 'LinkEntity',
          additional_data: { resource_type: 'Admin' }
        },
        {
          name: 'Status',
          value: 'status'
        },
        {
          name: 'Permission Level',
          value: 'permission_level'
        }
      ],
      unique_buttons: [
        { name: 'set_active_list', display_text: 'Active' },
        { name: 'set_expired_list', display_text: 'Expired' },
        { name: 'set_blocked_list', display_text: 'Blocked' }
      ]
    }
  },
  computed: {
    ...mapState(STORE_NAMESPACE, ['admin_list']),
    admins () {
      return this.admin_list.filter(
        (admin) => admin.status === this.stagedStatus
      )
    }
  },
  methods: {
    setActiveList () {
      this[FETCH_ALL]()
      this.stagedStatus = 'active'
    },
    setExpiredList () {
      this[FETCH_ALL]()
      this.stagedStatus = 'expired'
    },
    setBlockedList () {
      this[FETCH_ALL]()
      this.stagedStatus = 'blocked'
    },
    deleteAdmin (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.full_name,
        item_name: delete_data.full_name,
        method: 'deleteAdmin',
        method_params: { user_id: delete_data.user_id, id: delete_data.id }
      })
    },
    createAdmin () {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminListForm',
        is_create: true,
        modal_title: 'Create new Admin'
      })
    },
    editClick (data) {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminListForm',
        data,
        modal_title: 'Edit Admin'
      })
    },
    ...mapMutations('modals', ['create']),
    ...mapActions(STORE_NAMESPACE, [FETCH_ALL])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
